/* Import pages components */
import Home from '../views/home.vue'
import Register1 from '../views/register/register-enter-details.vue'
import Register2 from '../views/register/register-verify-email.vue'
import Register3 from '../views/register/register-enter-mobile-no.vue'
import Register4 from '../views/register/register-tnc.vue'
import Register5 from '../views/register/register-activate-biometry.vue'
import Register6 from '../views/register/register-biometry-success.vue'
import Register7 from '../views/register/register-enter-password.vue'
import Register8 from '../views/register/register-myinfo-email-password.vue'
import RegisterMyInfoCallback from '../views/register/register-myinfo-callback.vue'
import RegisterMyInfoVerifyDetail from '../views/register/register-myinfo-verify-detail.vue'
import RegisterEmailVerified from '../views/register/register-email-verified.vue'
import RegisterPersonaliseAccount from '../views/register/register-personalise-account.vue'

import BeneficiaryList from '../views/beneficiary/beneficiary-list.vue'
import BeneficiaryNewDetails from '../views/beneficiary/new-beneficiary-details.vue'
import BeneficiaryModify from '../views/beneficiary/beneficiary-modify.vue'
import BeneficiaryCreated from '../views/beneficiary/beneficiary-created.vue'

import SendMoneySelectBeneficiary from '../views/sendmoney/sendmoney-beneficiary-list.vue'
import SendMoneyPhilGovEnterDetail       from '../views/sendmoney/sendmoney-philgov-enter-detail.vue'
import SendMoneyEnterAmount       from '../views/sendmoney/sendmoney-enter-amount.vue'
import SendMoneyConfirmation      from '../views/sendmoney/sendmoney-confirmation.vue'
import SendMoneyPaymentDetail    from '../views/sendmoney/sendmoney-payment-detail.vue'
import SendMoneyPaymentSummary    from '../views/sendmoney/sendmoney-payment-summary.vue'
import SendMoneyContributionTable    from '../views/sendmoney/sendmoney-contribution-table.vue'
import SendMoneyCheckoutStatus from '../views/sendmoney/sendmoney-checkout-status.vue'
import ExchangeRateCalculator    from '../views/exchange-rate/fx-calculator.vue'
import AccountHome from '../views/account/account-home.vue'
import AccountInviteEarn from '../views/account/account-invite-earn.vue'
import AccountMyCoupon from '../views/account/account-my-coupon.vue'
import AccountMyDetails from '../views/account/account-my-details.vue'
import AccountEditDetail from '../views/account/account-edit-detail.vue'
import AccountInputPassword from '../views/account/account-input-password.vue'
import AccountEmailVerify from '../views/account/account-email-verify.vue'
import AccountHelpAndSupport from '../views/account/account-help-and-support.vue'
import AccountFXAlert from '../views/account/account-fx-alert.vue'
import AccountCreateAlert from '../views/account/account-create-fx-alert.vue'

import VerifyEKYCHome from '../views/ekyc/account-verify-home.vue'
import VerifyEKYCTypeList from '../views/ekyc/account-verify-type-list.vue'
import VerifyEKYCTakePhoto from '../views/ekyc/account-verify-take-photo.vue'
import VerifyPersonalDetail from '../views/ekyc/account-verify-personal-details.vue'
import VerifyEKYCComplete from '../views/ekyc/account-verify-completed.vue'

import TransactionHistory from '../views/transaction/transaction-history.vue'
import TransactionHistoryDetails from '../views/transaction/transaction-history-details.vue'
import TransactionModify from '../views/transaction/transaction-modify.vue'

import NotificationList from '../views/notification/notification-list.vue'
import NotificationDetail from '../views/notification/notification-details.vue'

import Login from '../views/login.vue'
import LoginSingpassCallback from '../views/login/login-singpass-callback.vue'
import Otp from '../views/otp.vue'
import Onboarding from '../views/onboarding.vue'
import Sample from '../views/sample2.vue'
import store from '../store/'
import Vue from '../main.js'
import TNC from '../views/tnc.vue'
import InviteEarn from '../views/invite-earn.vue'
import IETNC from '../views/invite-earn-tnc.vue'
import PrivacyPolicy from '../views/privacy-policy.vue'
import FAQ from '../views/faq.vue'
import Setting from '../views/setting.vue'
import ResetPassword1 from '../views/account/reset-password-email.vue'
import ResetPassword2 from '../views/account/reset-password-verify-email.vue'
import ResetPassword3 from '../views/account/reset-password.vue'
import ResetPassword4 from '../views/account/reset-password-complete.vue'

import Maintenance from '../views/maintenance.vue'
import ErrorPage from '../views/error.vue'

/* AXS Remittance */
import AXSRLandingpage from '../views/axsr-landingpage.vue'
import AXSRRegister1 from '../views/register/axsr-register-enter-details.vue'
import AXSRRegister2 from '../views/register/axsr-register-success.vue'
import AXSRRegister3 from '../views/register/axsr-register-redirect.vue'
import AXSRLogin from '../views/axsr-login.vue'


function unsecuredRoute(path, name, component, ...param) {
    return {
        path,
        name,
        async(to, from, resolve) {
            //console.log("TO : ", to)
            //console.log("unsecured route, from url : "+to.url+" ## "+store.state.registration.isAxsr+" ## "+to.url.indexOf("/guest-tnc"))
            if(to.url.indexOf("/guest-tnc") > -1 && to.query.axs){
                if(to.query.axs == "1"){
                    store.state.registration.isAxsr = true
                }else{
                    store.state.registration.isAxsr = false
                }
            }
            //console.log("unsecured route, isAXS ? "+store.state.registration.isAxsr)

            if (from.url == '/home' && to.url == '/') {
                // const tokenValid = Vue.isTokenValid()
                // console.log('tokenValid:'+tokenValid)
                // if (!tokenValid) {
                //     reject()
                // } else {
                //     store.dispatch('auth/logout')
                //     resolve({ component: component }, {...param})
                // }
            } else {
                resolve({ component: component }, {...param})
            }
        }
    }
}

function securedRoute(path, name, component) {
    return {
        path,
        name,
        async async(to, from, resolve, reject) {
            //console.log('access token:'+store.state.auth.accessToken)
            //store.state.auth.loggedIn = true ; // toberemove only for development only
            if(store.state.auth.accessToken){
                await store.commit('auth/loggedIn', store.state.auth.accessToken);
            }

            if (!store.state.auth.loggedIn) {
                console.log("LOGGED IN = FALSE")
                reject();

                const isAxsrState = store.state.registration.isAxsr;
                if(isAxsrState){
                    this.navigate('/axsr-login');
                }else{
                    this.navigate('/login');
                }
            } else {
                console.log("LOGGED IN = TRUE")
                const alive = Vue.checkTokenExpiry()
                //const alive = true  // toberemove only for development only
                console.log('alive:' + alive)
                alive ? resolve({ component: component }) : reject();
            }

        }
    }
}

export default [
    securedRoute('/home'                                    , "Home", Home),

    securedRoute('/beneficiary-list'                        , "Beneficiary - List", BeneficiaryList),
    securedRoute('/beneficiary-new-details'                 , "Beneficiary - Create" , BeneficiaryNewDetails),
    securedRoute('/beneficiary-modify'                      , "Beneficiary - Modify", BeneficiaryModify),
    securedRoute('/beneficiary-details'                     , "Beneficiary - Details", BeneficiaryCreated),

    securedRoute('/sendmoney/select-beneficiary'            , "Send Money - Select Beneficiary", SendMoneySelectBeneficiary),
    securedRoute('/sendmoney/choose-transaction-type'       , "Send Money - Select Transaction Type", SendMoneyPhilGovEnterDetail),
    securedRoute('/sendmoney/enter-amount'                  , "Send Money - Enter Amount", SendMoneyEnterAmount),
    securedRoute('/sendmoney/confirmation'                  , "Send Money - Confirm", SendMoneyConfirmation),
    securedRoute('/sendmoney/payment-detail'                , "Send Money - Payment Details", SendMoneyPaymentDetail),
    securedRoute('/sendmoney/payment-summary'               , "Send Money - Payment Summary", SendMoneyPaymentSummary),
    securedRoute('/sendmoney/contribution-table'            , "Send Money - Contribution", SendMoneyContributionTable),
    securedRoute('/exchangerate'                            , "Send Money - Exchange Rates", ExchangeRateCalculator),

    securedRoute('/account'                                 , "Account", AccountHome),
    securedRoute('/account/invite-earn'                     , "Account - Invite & Earn", AccountInviteEarn),
    securedRoute('/account/my-coupon'                       , "Account - My Coupon", AccountMyCoupon),
    securedRoute('/account/my-details'                      , "Account - My Details", AccountMyDetails),
    securedRoute('/account/edit-details'                    , "Account - Edit Details", AccountEditDetail),
    securedRoute('/account/input-password'                  , "Account - Input Password", AccountInputPassword),
    securedRoute('/account/email-verify'                    , "Account - Verify Email", AccountEmailVerify),
    securedRoute('/account/help-and-support'                , "Account - Help", AccountHelpAndSupport),
    securedRoute('/account/fx-alert'                        , "Account - FX Alert", AccountFXAlert),
    securedRoute('/account/create-alert'                    , "Account - Create Alert", AccountCreateAlert),

    securedRoute('/verify'                                  , "Verify", VerifyEKYCHome),
    securedRoute('/verify/type-list'                        , "Verify - Type List", VerifyEKYCTypeList),
    securedRoute('/verify/take-photo'                       , "Verify - Take Photo", VerifyEKYCTakePhoto),
    securedRoute('/verify/personal-detail'                  , "Verify - Confirm Details", VerifyPersonalDetail),
    securedRoute('/verify/completed'                        , "Verify - Complete", VerifyEKYCComplete),

    securedRoute('/transaction-history'                     , "Transaction History", TransactionHistory),
    securedRoute('/transaction-history-details'             , "Transaction History - Details", TransactionHistoryDetails),
    securedRoute('/transaction-modify'                      , "Modify Transaction", TransactionModify),

    securedRoute('/privacy-policy'                          , "Privacy Policy", PrivacyPolicy),
    securedRoute('/terms-and-condition'                     , "Terms and Conditions", TNC),
    securedRoute('/invite-earn-tnc'                         , "Invite & Earn", IETNC),
    securedRoute('/faq'                                     , "FAQ", FAQ),

    securedRoute('/notification'                            , "Notification", NotificationList),
    securedRoute('/notification/detail'                     , "Notification - Details", NotificationDetail),

    securedRoute('/setting'                                 , "Settings", Setting),

    unsecuredRoute('/'                                      , "Onboarding", Onboarding),
    unsecuredRoute('/login'                                 , "Login", Login),
    unsecuredRoute('/login-sp-callback'                     , "Login Singpass", LoginSingpassCallback),
    unsecuredRoute('/register'                              , "Register", Register1),
    unsecuredRoute('/register-verify-email'                 , "Register - Verify Email", Register2),
    unsecuredRoute('/register-mobile-no'                    , "Register - Input Contact No", Register3),
    unsecuredRoute('/register-tnc'                          , "Register - Terms and Conditions", Register4),
    unsecuredRoute('/register-activate-biometry'            , "Register - Biometry Activate", Register5),
    unsecuredRoute('/register-biometry-success'             , "Register - Biometry Success", Register6),
    unsecuredRoute('/register-input-password'               , "Register - Input Password", Register7),
    unsecuredRoute('/register-email-password'               , "Register - Input Email and Password", Register8),
    unsecuredRoute('/otp'                                   , "OTP", Otp),
    unsecuredRoute('/sample'                                , "UI Testing Page", Sample),
    unsecuredRoute('/sendmoney-checkout'                    , "Send Money - Checkout", SendMoneyCheckoutStatus),
    unsecuredRoute('/register-mi-callback'                  , "Register - MyInfo", RegisterMyInfoCallback),
    unsecuredRoute('/register-myinfo-callback'              , "Register - MyInfo", RegisterMyInfoCallback),
    unsecuredRoute('/register-myinfo-verify-detail'         , "Register - MyInfo Confirm", RegisterMyInfoVerifyDetail),
    unsecuredRoute('/register-email-verified'               , "Register - Email Verified", RegisterEmailVerified),
    unsecuredRoute('/reset-password-email'                  , "Reset Password - Input Email", ResetPassword1),
    unsecuredRoute('/reset-password-verify-email'           , "Reset Password - Verify Email", ResetPassword2),
    unsecuredRoute('/reset-password'                        , "Reset Password", ResetPassword3),
    unsecuredRoute('/reset-password-complete'               , "Reset Password - Complete", ResetPassword4),
    unsecuredRoute('/guest-invite-earn'                     , "Guest - Invite & Earn", InviteEarn),
    unsecuredRoute('/guest-invite-earn-tnc'                 , "Guest - Invite & Earn T&C", IETNC),
    unsecuredRoute('/guest-tnc'                             , "Guest - Terms and Conditions", TNC),
    unsecuredRoute('/maintenance'                           , "Maintenance", Maintenance),
    unsecuredRoute('/register-personalise-account'          , "Register - Personalise Account", RegisterPersonaliseAccount),

    /* AXS Remittance */
    unsecuredRoute('/customerDetails'                           , "Landingpage", AXSRLandingpage),
    unsecuredRoute('/axsr-register'                             , "Register", AXSRRegister1),
    unsecuredRoute('/axsr-register-success'                     , "Register - Success", AXSRRegister2),
    unsecuredRoute('/axsr-register-redirect'                    , "Register - Redirect", AXSRRegister3),
    unsecuredRoute('/axsr-login'                                , "Login", AXSRLogin),
    unsecuredRoute('/error'                                     , "Error", ErrorPage),
];
